<!-- Pricing -->
<div class="pricing-area ptb-80">
  <div class="container">
    <div class="section-title">
      <span class="sub-title" i18n="@@pricingSubtitle">Pricing</span>
      <h3 i18n="@@ourPlansTitle">Our Plans</h3>
      <div class="bar"></div>
      <p i18n="@@ourPlansSubTitle">
        The easiest and cheapest way of connecting to your customers, no surprises, no hidden fees!
      </p>
    </div>
    <div class="pricing-tab bg-color">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let item of products; index as index">
          <app-plan-item [product]="item"></app-plan-item>
        </div>
      </div>
    </div>
  </div>
  <div class="shape9">
    <img
      data-src="https://cdn.sanity.io/images/jizm7zxy/production/b0fe6a9d8b36e331b3dfe9cd46ebd224d10bd220-299x278.png?fm=webp&q=90"
      alt="shape1"
      data-sizes="auto"
      class="lazyload"
    />
  </div>
</div>
